module.exports = "images/mpg-big.png";